import { FC } from 'react';
import { media } from 'src/common/styles/breakpoints';
import { typography } from 'src/common/styles/typography';
import { VerificationStatusState } from 'src/pages/VerificationPage/reducers/verificationStatusReducer';
import styled, { css } from 'styled-components';

const Text = styled.h2`
  margin-top: 1.5rem;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 400;
  color: ${({ theme }) => theme.text.secondary};
  font-family: ${typography.fontFamilyDefault};

  & > b {
    font-weight: 700;
  }

  ${media.w.min.px576(css`
    margin-top: 2rem;
    font-weight: bold;
    font-size: 1.75rem;
    line-height: 2.6875rem;

    & > b {
      font-weight: 900;
    }
  `)};
`;

interface DescriptionProps {
  verificationState: VerificationStatusState;
}

export const VerificationPageDescription: FC<DescriptionProps> = ({
  verificationState,
}) => {
  switch (true) {
    case verificationState.isDownloading:
    case verificationState.isAnalyzing:
      return (
        <Text>
          Aktualnie trwa pobieranie historii transakcji z Twojego rachunku
          bankowego. Następnie nastąpi analiza danych, po której poinformujemy
          Cię o dalszych krokach procesu. Prosimy nie zamykać tej zakładki ani
          okna przeglądarki.
        </Text>
      );
    case verificationState.isExpired:
      return (
        <Text>
          Przepraszamy, Twój czas na przejście weryfikacji został przekroczony.
          Spróbuj ponownie rozpocząć proces.
        </Text>
      );
    case verificationState.isSuccess:
      return (
        <Text>
          Przepraszamy, ta weryfikacja nie jest aktywna. Spróbuj ponownie
          rozpocząć proces.
        </Text>
      );
    default:
      return (
        <Text>
          Zakończyliśmy pobierać historię transakcji z Twojego rachunku
          bankowego oraz analizę danych. Możesz teraz przejść z powrotem do
          procesu partnera klikając na przycisk <b>Przejdź dalej</b> poniżej.
        </Text>
      );
  }
};
